module.exports = __webpack_public_path__ + "static/media/post-info-icon.b1c43265.svg";